export const stellaConstants = {
    SET_SEQUENCE_TMP_FILE: "capture_load_sequence_file",
    SET_SEQUENCE: "set_sequence",
    SET_SCHEDULER: "set_scheduler",
    SET_PROMPT_ID: "set_prompt_id",
    ADD_EXECUTED_PROMPT: "add_executed_prompt",
    SET_SHOW_EXAMPLES: "set_show_examples",
    SET_STELLA_PARAMETER_VALUE: "SET_STELLA_PARAMETER_VALUE"
}